const AppConf = {
	venue_id:'',
}
export default AppConf;


// WEBPACK FOOTER //
// ./src/AppConf.js